import { z } from "zod";

export const multiresumeAuthProviderSchema = z.enum(["better-auth", "supabase"]).default("better-auth");

export type MultiResumeAuthProvider = z.infer<typeof multiresumeAuthProviderSchema>;

export function isSupabaseAuthProvider(provider: MultiResumeAuthProvider) {
  return provider === "supabase";
}
